import React, { useState, useEffect } from "react";

const countryCodes = [
  { code: "+351", country: "Portugal", flag: "🇵🇹" },
  { code: "+34", country: "Spain", flag: "🇪🇸" },
  { code: "+33", country: "France", flag: "🇫🇷" },
  { code: "+49", country: "Germany", flag: "🇩🇪" },
  { code: "+39", country: "Italy", flag: "🇮🇹" },
  { code: "+44", country: "United Kingdom", flag: "🇬🇧" },
  { code: "+31", country: "Netherlands", flag: "🇳🇱" },
  { code: "+32", country: "Belgium", flag: "🇧🇪" },
  { code: "+41", country: "Switzerland", flag: "🇨🇭" },
  { code: "+43", country: "Austria", flag: "🇦🇹" },
  { code: "+45", country: "Denmark", flag: "🇩🇰" },
  { code: "+46", country: "Sweden", flag: "🇸🇪" },
  { code: "+47", country: "Norway", flag: "🇳🇴" },
  { code: "+358", country: "Finland", flag: "🇫🇮" },
  { code: "+1", country: "United States", flag: "🇺🇸" },
  { code: "+1", country: "Canada", flag: "🇨🇦" },
  { code: "+55", country: "Brazil", flag: "🇧🇷" },
  { code: "+54", country: "Argentina", flag: "🇦🇷" },
  { code: "+52", country: "Mexico", flag: "🇲🇽" },
  { code: "+86", country: "China", flag: "🇨🇳" },
  { code: "+81", country: "Japan", flag: "🇯🇵" },
  { code: "+82", country: "South Korea", flag: "🇰🇷" },
  { code: "+91", country: "India", flag: "🇮🇳" },
  { code: "+61", country: "Australia", flag: "🇦🇺" },
  { code: "+64", country: "New Zealand", flag: "🇳🇿" },
];

const PhoneInput = ({ value, onChange, name }) => {
  const [selectedCode, setSelectedCode] = useState("+351");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Initialize from existing value if provided
  useEffect(() => {
    if (value && value !== selectedCode + phoneNumber) {
      // Parse existing value to extract country code and phone number
      const country = countryCodes.find(c => value.startsWith(c.code));
      if (country) {
        setSelectedCode(country.code);
        setPhoneNumber(value.substring(country.code.length));
      }
    }
  }, [value, selectedCode, phoneNumber]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const phoneContainer = document.querySelector('.phone-input-container');
      if (phoneContainer && !phoneContainer.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleCodeSelect = (code) => {
    setSelectedCode(code);
    setIsDropdownOpen(false);
    // Update the full phone number
    const fullNumber = code + phoneNumber;
    onChange({ target: { name, value: fullNumber } });
  };

  const handlePhoneChange = (e) => {
    const number = e.target.value;
    setPhoneNumber(number);
    // Update the full phone number
    const fullNumber = selectedCode + number;
    onChange({ target: { name, value: fullNumber } });
  };

  const selectedCountry = countryCodes.find(c => c.code === selectedCode);

  return (
    <div className="phone-input-container">
      <div className="country-code-selector">
        <div 
          className="selected-code"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <span className="flag">{selectedCountry?.flag}</span>
          <span className="code">{selectedCode}</span>
          <span className="dropdown-arrow">▼</span>
        </div>
        
        {isDropdownOpen && (
          <div className="country-dropdown">
            {countryCodes.map((country, index) => (
              <div
                key={index}
                className="country-option"
                onClick={() => handleCodeSelect(country.code)}
              >
                <span className="flag">{country.flag}</span>
                <span className="code">{country.code}</span>
                <span className="country-name">{country.country}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <input
        type="tel"
        value={phoneNumber}
        onChange={handlePhoneChange}
        placeholder="Phone Number"
        className="phone-number-input"
      />
    </div>
  );
};

export default PhoneInput;